import { creatorbase, creatorbaseQueries } from '@round/api';
import { useDeleteCampaign } from '@round/creatorbase-helpers/api-hooks';
import { useQueryClient } from '@tanstack/react-query';
import useInvalidateProjectCampaignContext from './useInvalidateProjectCampaignContext';

type CallbackOptions = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

// useDeleteCampaign invalidates every campaign query (keys.all) on success, which is broader
// than this project. Acceptable for now — observed queries off this project just get marked
// stale and only refetch when next visited.
export default function useDeleteProjectCampaign() {
    const queryClient = useQueryClient();
    const invalidateProjectCampaignContext = useInvalidateProjectCampaignContext();
    const { deleteOne: cbDeleteOne, isLoading, error } = useDeleteCampaign(undefined);

    const deleteOne = (
        campaign: Pick<creatorbase.Campaign, 'id' | 'project_id' | 'platform'>,
        options?: CallbackOptions
    ) => {
        cbDeleteOne(campaign.id, {
            onSuccess: () => {
                invalidateProjectCampaignContext({
                    project_id: campaign.project_id,
                    platform: campaign.platform,
                });
                queryClient.removeQueries({
                    queryKey: creatorbaseQueries.aggregatedPostStats.keys.detail({ campaign_id: campaign.id }),
                });
                options?.onSuccess?.();
            },
            onError: options?.onError,
        });
    };

    return { deleteOne, isLoading, error };
}
